import React, { useState } from 'react'
import styles from './index.module.scss'
import Pdf from './pdf'

const PdfViewer = () => {
  const [lookPdf, setLookPdf] = useState({ url: '', show: false })
  window.setPdfState = setLookPdf
  return (
    <div className={styles.pdfViewer} style={{ display: lookPdf.show ? 'block' : 'none' }}>
      <div
        className='back'
        onClick={e => {
          e.stopPropagation()
          setLookPdf({ url: lookPdf.url, show: false })
        }}
        id='Zback'
      >
        <img className='backImg' src={require(`@/assets/img/btn_back.png`)} alt='' />
      </div>
      <Pdf url={lookPdf.url} />
    </div>
  )
}

const MemoPdfViewer = React.memo(PdfViewer)

export default MemoPdfViewer
